import Card from "./Card"
import React, { useState, useRef, useEffect } from 'react';
import { AnimatePresence, LayoutGroup, motion, PanInfo, useAnimation, useMotionValue } from 'framer-motion';

export class TeamMember 
{
    name: string = "";
    title: string = "";
    src: string = "";
    description: string = "";
}

const team: Array<TeamMember> = [
    {
        name: "mgr Dorota Mróz",
        title: "Założycielka „CUDAki”, pedagog specjalny, logopeda kliniczny i neurologopeda",
        src: "/Testimonials/dorota mroz.jpg",
        description: `W swojej pracy patrzę na pacjenta holistycznie, ponieważ wiem, że tylko takie podejście zapewnia skuteczną terapię. 
        Cały czas rozwijam swoje umiejętności aby sprostać potrzebom dzieci i rodziców. 
        W swojej pracy korzystam z wielu metod min: terapii manualnej, miofunkcjonalnej, tapingu strefy orofacjalnej oraz elektrostymulacji narządów artykulacyjnych. 
        Ważna dla mnie jest relacja z dzieckiem oraz wytworzenie poczucia bezpieczeństwa w przestrzeni gabinetowej. 
        Pracuję z pacjentami z opóźnionym rozwojem mowy, wadami artykulacyjnymi, niewłaściwymi funkcjami prymarnymi oraz pacjentami ortodontycznymi.
        W wolnej chwili tańczę, piekę ciasta, kupuje nowe ubrania bądź odpisuję na Państwa wiadomości.`
    },
    {
        name: "mgr Klaudia Kaliska",
        title: "Terapeuta pedagogicznym oraz trener TUS",
        src: "/Testimonials/klaudia kaliska.jpg",
        description: `W swojej pracy koncentruję się na indywidualnym podejściu, dostosowując metody wsparcia do potrzeb i możliwości każdego dziecka.
        Pomagam dzieciom pokonywać bariery edukacyjne, wzmacniając ich kompetencje i budując poczucie własnej skuteczności.
        Jako trener TUS wspieram rozwój umiejętności społecznych, tworzę przestrzeń do wyrażania emocji oraz poszukiwania konstruktywnych strategii radzenia sobie z wyzwaniami.
        Dbam o to, aby każde dziecko mogło pracować w atmosferze bezpieczeństwa, zaufania i akceptacji.
        Moim celem jest wspieranie harmonijnego rozwoju opartego na mocnych stronach, zainteresowaniach i potencjale młodych pacjentów.
        W wolnej chwili czytam książki piekę bezy i zwiedzam świat.`
    },
    {
        name: "mgr Wioletta Szatkowska",
        title: "Logopeda i pedagog specjalny",
        src: "/Testimonials/wioletta szatkowska.jpg",
        description: `Wspieram rozwój dzieci, łącząc terapię z zabawą i budując bezpieczną, przyjazną atmosferę. 
        Każdy pacjent to dla mnie wyjątkowa osobowość - dlatego pracuję w oparciu o indywidualnie dobrany program terapeutyczny.
        Na co dzień pomagam dzieciom ze spektrum autyzmu, afazją, opóźnionym rozwojem mowy oraz dyslalią. 
        Pracuję również w przedszkolu terapeutycznym.
        W wolnych chwilach sięgam po dobrą książkę, gotuję, podróżuję i cenię czas spędzony z rodziną i przyjaciółmi.`
    },
    {
        name: "mgr Angelika Ada Skrobacka",
        title: "Neurologopeda i pedagog specjalny",
        src: "/Testimonials/angelika skrobacka.jpg",
        description: `Każdą terapię dostosowuję indywidualnie do potrzeb pacjenta, dbając o przyjazną atmosferę oraz poczucie bezpieczeństwa. 
        Specjalizuję się w pracy z dziećmi od 3 roku życia z opóźnionym lub zaburzonym rozwojem mowy, niedosłuchem, wadami wymowy oraz zaburzonymi funkcjami prymarnymi, a także z osobami w trakcie leczenia ortodontycznego. 
        Podczas terapii wykorzystuję metody takie jak elektrostymulacja, kinesiotaping czy terapia manualna.
        Po pracy lubię ćwiczyć jogę oraz piec słodkości.`
    },
    {
        name: "mgr Katarzyna Szczepara",
        title: "Neurologopeda i filolog polski",
        src: "/Testimonials/katarzyna szczepara.jpg",
        description: `Jestem absolwentką filologii polskiej ze specjalnością logopedyczną na Uniwersytecie im. Adama Mickiewicza w Poznaniu oraz studiów podyplomowych z neurologopedii klinicznej na Uniwersytecie Medycznym im. Karola Marcinkowskiego w Poznaniu. 
        Pracuję z dziećmi z opóźnionym rozwojem mowy, wadami wymowy, afazją, w spektrum autyzmu. 
        Cenię sobie przyjazną atmosferę podczas zajęć oraz indywidualne podejście do każdego pacjenta, dlatego dostosowuję terapię do potrzeb, możliwości i zainteresowań dziecka. 
        W wolnym czasie układam puzzle, uczę się języka obcego i śledzę piłkarskie rozgrywki.`
    },
    {
        name: "mgr Natalia Kosmala",
        title: "Logopeda i filolog polski",
        src: "/Testimonials/natalia kosmala.jpg",
        description: `Interesuje mnie nauka poprzez zabawę, ponieważ wtedy dziecko w naturalnie odkrywa swoje możliwości. 
        Najważniejsze jest dla mnie stworzenie relacji opartej na zaufaniu i poczuciu bezpieczeństwa, dzięki której dziecko może czuć się swobodnie i w pełni wykorzystywać swój potencjał. 
        W pracy indywidualnie dostosowuję formy pracy w terapii, skupiając się na potrzebach pacjenta. Chętnie pomagam dzieciom z dyslalią, afazją, jąkaniem, zaburzeniami funkcji prymarnych czy opóźnionym rozwojem mowy. 
        Logopedia to moja pasja, dlatego chętnie poszerzam swoje kwalifikacje uczestnicząc w szkoleniach dotyczących terapii miofunkcjonalnej, funkcji prymarnych czy korekcji wad artykulacyjnych.
        W wolnym czasie lubię chodzić na koncerty, spacerować i spędzać czas z bliskimi.`
    }
]

const TestimonialsPresenter: React.FC = () => {
    const [active, setActive] = useState<TeamMember>(team[0]);

    return (
        <>
            <motion.div 
                className="flex gap-4 mt-4 w-full flex-wrap justify-center"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                viewport={{ margin: "-20%", once: true}}>
                {team.map((member, index) => (
                    <Card index={index} content={member} isActive={active === member} setActive={setActive}/>
                ))}
            </motion.div>
            <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                viewport={{ margin: "-20%", once: true}}
                className="xl:w-[50vw] w-[90vw]">
            <AnimatePresence mode="wait">
                <motion.div 
                    key={active.name}
                    initial={{opacity: 0, x: -200}}
                    animate={{opacity: 1, x: 0}}
                    exit={{opacity: 0, x: 200}}
                    transition={{duration: 0.3}}
                    className="flex justify-center items-start mt-10 mb-10">
                    <motion.div className="flex lg:flex-row flex-col items-center justify-start gap-6">
                        <motion.div className={`flex-shrink-0 sm:w-[250px] w-[90vw] shadow-[0_5px_10px_rgba(0,0,0,0.5)] rounded-lg`}>
                            <img src={active.src} alt="avatar" className="object-fit object-top rounded-lg"/>
                        </motion.div>
                        {
                            <motion.div className="flex flex-col items-start">
                                <motion.h2 
                                    className="text-xl mt-2" style={{ whiteSpace: "pre-line" }}>
                                    {`${active.name}
                                    ${active.title}`}
                                    <motion.div className="line w-auto h-[2px] mb-2" 
                                    initial={{scaleX: 0}} 
                                    animate={{scaleX: 1}} 
                                    transition={{ duration: 0.3 }} />
                                </motion.h2>

                                <motion.p
                                    className="text-justify">
                                    {active.description}
                                </motion.p>
                            </motion.div>
                        }
                    </motion.div>
                </motion.div>
            </AnimatePresence>
        </motion.div>
    </>
)}

export default TestimonialsPresenter;